/* eslint-disable react/prop-types */
import { Descriptions, Typography } from 'antd';
import { type TFunction, useTranslation } from 'react-i18next';
import { type BasicRouterLayoutSpecsFragment } from '../../../../../../api/fragments/BasicRouterLayoutSpecs';
import {
    ApplyBasicLayoutOnRouterDocument,
    type ApplyBasicLayoutOnRouterMutation,
    type ApplyBasicLayoutOnRouterMutationVariables,
} from '../../../../../../api/mutations/applyBasicLayoutOnRouter';
import { type BasicRouterSettings } from '../../../../../../api/types';
import CheckboxField from '../../../../../../components/fields/CheckboxField';
import renderBooleanIcon from '../../../../../../utilities/renderBooleanIcon';
import { type LayoutImplementation } from './types';

const implementation: LayoutImplementation<BasicRouterLayoutSpecsFragment, BasicRouterSettings> = {
    getTitle: (t: TFunction) => t('routerDetails:layouts.basic.title'),
    ViewPanelComponent: ({ layout }) => {
        const { t } = useTranslation(['routerDetails']);

        return (
            <>
                <Typography.Paragraph>{t('routerDetails:layouts.basic.description')}</Typography.Paragraph>
                <Descriptions size="small" bordered>
                    <Descriptions.Item label={t('routerDetails:layouts.basic.contentView.withAdminButton')}>
                        {renderBooleanIcon(layout.withAdminButton)}
                    </Descriptions.Item>
                </Descriptions>
            </>
        );
    },
    FormComponent: () => {
        const { t } = useTranslation(['routerDetails']);

        return (
            <CheckboxField
                {...t('routerDetails:layouts.fields.withAdminButton', { returnObjects: true })}
                name="settings.withAdminButton"
            />
        );
    },
    applyRouter: (apolloClient, routerId, settings) =>
        apolloClient.mutate<ApplyBasicLayoutOnRouterMutation, ApplyBasicLayoutOnRouterMutationVariables>({
            mutation: ApplyBasicLayoutOnRouterDocument,
            variables: { routerId, settings },
        }),
    defaultSettings: { withAdminButton: false },
    getInitialValues: layout => ({ withAdminButton: layout.withAdminButton }),
};

export default implementation;
